import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Title,
} from "@clipboard-health/ui-components";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { useEmbeddedMode } from "@src/appV2/EmbeddedMode/EmbeddedModeContext";
import { openBrowser } from "@src/appV2/lib";
import { DELETE_ACCOUNT_FULL_PATH } from "@src/appV2/redesign/Accounts/paths";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { PRIVACY_POLICY_URL } from "../../constants/urls";

export function AccountsPageLegalSection() {
  const history = useHistory();
  const worker = useDefinedWorker();
  const { isEmbedded } = useEmbeddedMode();
  const workerHasRequestedDeletion = worker.stage === WorkerStage.DELETION_REQUESTED;

  return (
    <>
      <Title semibold component="h4">
        Legal
      </Title>{" "}
      {!isEmbedded && (
        <ListItem divider>
          <ListItemButton
            onClick={() => {
              history.push(DeprecatedGlobalAppV1Paths.PROFILE_CONTRACT);
            }}
          >
            <ListItemIcon iconType="building" />
            <ListItemText primary="Contractor Agreement" />
          </ListItemButton>
        </ListItem>
      )}
      <ListItem divider>
        <ListItemButton
          onClick={async () => {
            await openBrowser(PRIVACY_POLICY_URL);
          }}
        >
          <ListItemIcon iconType="privacy" />
          <ListItemText primary="Privacy Policy" />
        </ListItemButton>
      </ListItem>
      <ListItem divider>
        <ListItemButton
          disabled={workerHasRequestedDeletion}
          onClick={() => {
            history.push(DELETE_ACCOUNT_FULL_PATH);
          }}
        >
          <ListItemIcon iconType="remove" />
          <ListItemText
            primary={
              workerHasRequestedDeletion ? "Account Deletion Request Pending" : "Delete Account"
            }
          />
        </ListItemButton>
      </ListItem>
    </>
  );
}
